import React, { FC, MouseEventHandler } from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { APP_NOTIFICATION_COMPONENT_STATIC_TEXTS } from "../../constants";

interface IMarkAllAsReadButtonMarkAllAsReadButtonProps {
    onMarkAllAsRead: MouseEventHandler;
    isMarkingAllNotificationsAsRead: boolean;
}

const MarkAllAsReadButton: FC<IMarkAllAsReadButtonMarkAllAsReadButtonProps> = (
    props
) => {
    const { onMarkAllAsRead, isMarkingAllNotificationsAsRead } = props;

    return (
        <Tooltip
            title={
                APP_NOTIFICATION_COMPONENT_STATIC_TEXTS.MARK_ALL_AS_READ_BUTTON.LABEL
            }
        >
            <IconButton
                size="small"
                sx={{
                    marginLeft: "16px",
                    ":hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
                }}
                onClick={onMarkAllAsRead}
            >
                {isMarkingAllNotificationsAsRead ? (
                    <CircularProgress size={22.5} />
                ) : (
                    <TaskAltOutlinedIcon />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default MarkAllAsReadButton;
